import React, { SVGProps } from 'react';

const LeftArrowIcon = ({
  width = 6,
  height = 10,
  className,
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    className={className}
    data-palette="LeftArrowIcon">
    <path
      fill="var(--secondaryText)"
      d="m2.121 5 3.713 3.712-1.06 1.061L0 5 4.773.227l1.061 1.06L2.121 5z"
    />
  </svg>
);

export default LeftArrowIcon;
